import { Box } from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

interface WrapperProps {
  isMobileCardListMode?: boolean;
}
export const CardItemWrapper = styled(Box)<WrapperProps>`
  ${({ isMobileCardListMode: isCardListMode }) => {
    if (isCardListMode) {
      return css``;
    }
    return css`
      min-width: 508px;
      width: calc(33.333% - ${({ theme }) => theme.spacings.spacing16});
    `;
  }}

  min-height: 240px;
  cursor: pointer;
`;
